// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'
import { TCompany } from '../../automationObjects/Agents/Organizations/Company/types';



// Define a service using a base URL and expected endpoints
export const tenantAPi = createApi({
  reducerPath: 'tenantAPi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.tenantAPiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['Tenants'],
  endpoints: (builder) => ({
    getTenantById: builder.query<TCompany, string>({
      query: (id) => `/${id}`,
    }),
    /*getTenants: builder.query<TenantSummaryDto[], void>({
      query: () => `/`,
      providesTags: ['Tenants'],
    }),*/
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTenantByIdQuery,
 // useGetTenantsQuery,
} = tenantAPi